import { Navigate } from "react-router-dom";

import Authenticated from "src/components/Authenticated";
import BaseLayout from "src/layouts/BaseLayout";
import CollapsedSidebarLayout from "src/layouts/CollapsedSidebarLayout";

import accountRoutes from "./account";
import baseRoutes from "./base";
import containersRoutes from "./containers";
import customerRoutes from "./customers";
import dashboardsRoutes from "./dashboards";
import loomRoutes from "./loom";
import orderRoutes from "./orders";
import productRoutes from "./products";
import referenceRoutes from "./references";
import securityRouters from "./security";
import userRoutes from "./users";

const router = [
  {
    path: "account",
    children: accountRoutes,
  },
  {
    path: "*",
    element: <BaseLayout />,
    children: baseRoutes,
  },

  {
    path: "/",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "/",
        element: <Navigate to="home" replace />,
      },
      {
        path: "home",
        children: dashboardsRoutes,
      },
      {
        path: "orders",
        children: orderRoutes,
      },
      {
        path: "products",
        children: productRoutes,
      },
      {
        path: "customers",
        children: customerRoutes,
      },
      {
        path: "users",
        children: userRoutes,
      },
      {
        path: "references",
        children: referenceRoutes,
      },
      {
        path: "containers",
        children: containersRoutes,
      },
      {
        path: "security",
        children: securityRouters,
      },
      {
        path: "loom-test",
        children: loomRoutes,
      },
    ],
  },
];

export default router;
